// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ref--9-1!../../../node_modules/react-flexbox-grid/dist/react-flexbox-grid.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "body.login{margin-top:40px;background-color:#f5f5f5}\n", "",{"version":3,"sources":["LoginLayout.scss"],"names":[],"mappings":"AAA6D,WAAW,eAAe,CAAC,wBAAwB","file":"LoginLayout.scss","sourcesContent":["@import url(~react-flexbox-grid/dist/react-flexbox-grid.css);body.login{margin-top:40px;background-color:#f5f5f5}\n"]}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
